module.exports = __webpack_public_path__ + "static/media/Tarin_Kerishma_Resume.07be20a0.pdf";